import type { DiscontinuedMedicationsParams } from '@/api/prescriptions/getPrescriptionsWithDiscontinuedMedications';
import { getPrescriptionsWithDiscontinuedMedications } from '@/api/prescriptions/getPrescriptionsWithDiscontinuedMedications';
import { QueryKey } from '@/data/query';
import { useQuery } from '@tanstack/react-query';

const useGetPrescriptionsWithDiscontinuedMedications = (params: DiscontinuedMedicationsParams) => {
  const queryKey = [QueryKey.GetGenerativeScriptingPrescriptions, params];
  const { isLoading, data, error, refetch } = useQuery({
    queryKey,
    queryFn: () => getPrescriptionsWithDiscontinuedMedications(params)
  });

  return {
    loading: isLoading,
    data,
    error,
    doGet: refetch
  };
};

export { useGetPrescriptionsWithDiscontinuedMedications };
